import { css } from 'styled-components';
import { rgba } from 'polished';

import { cFFFFFF } from '#/colors';

export const APP_BAR_HEIGHT = '60px';

export const navItemStyles = css`
  color: ${rgba(cFFFFFF, 0.5)};
  height: 28px;
  font-size: 14px;
  padding: 5px 0;
  display: grid;
  grid-auto-flow: column;
  gap: 3px;
  place-items: center;
  position: relative;
  background: none;
  border: none;
  border-radius: 4px;
  margin: none;
  font-weight: 700;

  &:hover {
    color: ${rgba(cFFFFFF, 0.7)};
  }

  &:active {
    color: ${cFFFFFF};
  }
`;
